import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-auto-refresh',
  templateUrl: './auto-refresh.component.html',
  styleUrls: ['./auto-refresh.component.css'],
  standalone: false
})
export class AutoRefreshComponent implements OnInit {
  @Output() refresh = new EventEmitter();

  timerPaused: boolean = true;
  defaultTime: number = 300;
  timeLeft: number = this.defaultTime;
  intervals: any[] = [];

  constructor() { }

  ngOnInit() {
    this.startTimer();
  }

  startTimer() {
    if (this.timerPaused) {
      this.timerPaused = false;
      this.intervals.push(setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
      this.refresh.emit();
        this.timeLeft = this.defaultTime;
      }
      }, 1000));
    }
  }

  pauseTimer() {
    this.timerPaused = true;
    this.intervals.forEach(interval => {
      clearInterval(interval);
    });
  }
}
